document.addEventListener('DOMContentLoaded', function() {
    "use strict";
    
    // Add click event listeners to all layout selection buttons
    const selectButtons = document.querySelectorAll('.zwssgr-select-btn');
    
    selectButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            
            const layoutOption = this.getAttribute('data-option');
            const displayOption = this.getAttribute('data-display-option');
            const postId = new URLSearchParams(window.location.search).get('zwssgr_widget_id');
            
            if (!postId || !layoutOption || !displayOption) {
                console.error('Missing required parameters');
                return;
            }
            
            // Show loading indicator
            const loadingIndicator = document.createElement('div');
            loadingIndicator.className = 'zwssgr-loading';
            loadingIndicator.innerHTML = 'Processing...';
            document.body.appendChild(loadingIndicator);
            
            // Make a direct AJAX call to update the shortcode
            const xhr = new XMLHttpRequest();
            xhr.open('POST', zwssgr_admin.ajax_url, true);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            
            const params = new URLSearchParams({
                action: 'zwssgr_update_shortcode',
                post_id: postId,
                layout: displayOption,
                layout_option: layoutOption
            });
            
            xhr.onload = function() {
                if (xhr.status === 200) {
                    try {
                        const response = JSON.parse(xhr.responseText);
                        if (response.success) {
                            // Redirect to the selected option tab
                            window.location.href = `${window.location.origin}${window.location.pathname}?page=zwssgr_widget_configurator&tab=tab-selected&selectedOption=${layoutOption}&zwssgr_widget_id=${postId}`;
                        } else {
                            alert('Error: ' + (response.data ? response.data.message : 'Unknown error'));
                            document.body.removeChild(loadingIndicator);
                        }
                    } catch (e) {
                        console.error('Invalid response', e);
                        document.body.removeChild(loadingIndicator);
                    }
                } else {
                    console.error('Request failed', xhr.statusText);
                    document.body.removeChild(loadingIndicator);
                }
            };
            
            xhr.onerror = function() {
                console.error('Request failed');
                document.body.removeChild(loadingIndicator);
            };
            
            xhr.send(params.toString());
        });
    });
});
